<template>
      <PaymentComponent />
</template>

<script>
import TopNavbar from '@/components/user/layout/TopNavbar.vue';
import PaymentComponent from '@/components/user/viewComponent/payment/PaymentComponent.vue';

export default {
  name: 'PaymentViewComponent',
  components: {
    TopNavbar,
    PaymentComponent,
  },
}
</script>